import { ReactNode } from 'react'
import { Series } from '../types'
import Tile from './Tile'
import Chart from './Chart'

interface TileGraphProps {
    title: ReactNode
    children: ReactNode
    series?: Series[]
    dateFormat?: string
    formatter?: (value: number) => string
    onClick?: () => void
}

export default function TileGraph({ title, children, series, dateFormat, formatter, onClick }: TileGraphProps) {
    return (
        <Tile
            title={title}
            size="large"
            onClick={onClick}
        >
            {children}
            {series && (
                <div style={{ marginTop: 8 }}>
                    <Chart
                        series={series}
                        maxHeight={80}
                        showLegend={false}
                        showAxes={false}
                        dateFormat={dateFormat}
                        formatter={formatter}
                    />
                </div>
            )}
        </Tile>
    )
}
